import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

import {
    DeletionSubmissionFormData,
    EmployeeUserAccountToDelete,
    PartnersToBeDeleted,
} from './types';

export type PostDeletePreviewErrorResponse = Api.Response.Failure<
    keyof DeletionSubmissionFormData
>;

export type PostDeletePreviewResponse = {
    allPartnersToDelete: Array<PartnersToBeDeleted>;
    employeeUserAccountsToDelete: Array<EmployeeUserAccountToDelete>;
    willDeleteUser: boolean;
};

export type PostDeletePreviewSuccessResponse =
    Api.Response.Success<PostDeletePreviewResponse>;

export const usePostDeletePreview = (): UseMutationResult<
    PostDeletePreviewSuccessResponse,
    PostDeletePreviewErrorResponse,
    DeletionSubmissionFormData
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: '/api/profile/delete-profile-preview/',
        }),
    );
};

export type PostDeleteErrorResponse = Api.Response.Failure;

export type PostDeleteResponse = {
    response: string;
};

export type PostDeleteSuccessResponse =
    Api.Response.Success<PostDeleteResponse>;

export const usePostDelete = (): UseMutationResult<
    PostDeleteSuccessResponse,
    PostDeleteErrorResponse,
    DeletionSubmissionFormData
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: '/api/profile/delete-profile/',
        }),
    );
};
